import React from "react";

import * as styles from "./styles";

export function NoDataContent({ text }: { text: string }) {
  return (
    <div className={styles.blankState}>
      <p>{text}</p>
    </div>
  );
}
